import * as Font from "expo-font";

const UseFonts = async () => {
    await Font.loadAsync({
        'Roboto-Light': require('./App/Fonts/Roboto-Light.ttf'),
        'Roboto-Medium': require('./App/Fonts/Roboto-Medium.ttf'),
        'Roboto-Bold': require('./App/Fonts/Roboto-Bold.ttf'),
    });
};

export default UseFonts;